import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

type TariffInfo = {
    month: string[];
    year: string[];
};

const saleDevPlans: TariffInfo = {
    month: [
        'W1GB_1m_separate_sale_device_4',
        'W1GB_1m_separate_sale_device_5',
        'W1GB_1m_separate_sale_device_6',
        'W1GB_1m_separate_sale_device_7',
        'W1GB_1m_separate_sale_device_8',
        'W1GB_1m_separate_sale_device_9',
        'W1GB_1m_separate_sale_device_10',
        'W1GB_1m_separate_sale_device_11',
        'W1GB_1m_separate_sale_device_12',
        'W1GB_1m_separate_sale_device_13',
        'W1GB_1m_separate_sale_device_14',
        'W1GB_1m_separate_sale_device_15',
        'W1GB_1m_separate_sale_device_16',
        'W1GB_1m_separate_sale_device_17',
        'W1GB_1m_separate_sale_device_18',
        'W1GB_1m_separate_sale_device_19',
        'W1GB_1m_separate_sale_device_20',
    ],
    year: [
        'W1GB_1y_separate_sale_device_4',
        'W1GB_1y_separate_sale_device_5',
        'W1GB_1y_separate_sale_device_6',
        'W1GB_1y_separate_sale_device_7',
        'W1GB_1y_separate_sale_device_8',
        'W1GB_1y_separate_sale_device_9',
        'W1GB_1y_separate_sale_device_10',
        'W1GB_1y_separate_sale_device_11',
        'W1GB_1y_separate_sale_device_12',
        'W1GB_1y_separate_sale_device_13',
        'W1GB_1y_separate_sale_device_14',
        'W1GB_1y_separate_sale_device_15',
        'W1GB_1y_separate_sale_device_16',
        'W1GB_1y_separate_sale_device_17',
        'W1GB_1y_separate_sale_device_18',
        'W1GB_1y_separate_sale_device_19',
        'W1GB_1y_separate_sale_device_20',
    ],
};

const saleDevWithSubsPlans: TariffInfo = {
    month: [
        'W1TB_1m_separate_sale_with_sub_device_4',
        'W1TB_1m_separate_sale_with_sub_device_5',
        'W1TB_1m_separate_sale_with_sub_device_6',
        'W1TB_1m_separate_sale_with_sub_device_7',
        'W1TB_1m_separate_sale_with_sub_device_8',
        'W1TB_1m_separate_sale_with_sub_device_9',
        'W1TB_1m_separate_sale_with_sub_device_10',
        'W1TB_1m_separate_sale_with_sub_device_11',
        'W1TB_1m_separate_sale_with_sub_device_12',
        'W1TB_1m_separate_sale_with_sub_device_13',
        'W1TB_1m_separate_sale_with_sub_device_14',
        'W1TB_1m_separate_sale_with_sub_device_15',
        'W1TB_1m_separate_sale_with_sub_device_16',
        'W1TB_1m_separate_sale_with_sub_device_17',
        'W1TB_1m_separate_sale_with_sub_device_18',
        'W1TB_1m_separate_sale_with_sub_device_19',
        'W1TB_1m_separate_sale_with_sub_device_20',
    ],
    year: [
        'W1TB_1y_separate_sale_with_sub_device_4',
        'W1TB_1y_separate_sale_with_sub_device_5',
        'W1TB_1y_separate_sale_with_sub_device_6',
        'W1TB_1y_separate_sale_with_sub_device_7',
        'W1TB_1y_separate_sale_with_sub_device_8',
        'W1TB_1y_separate_sale_with_sub_device_9',
        'W1TB_1y_separate_sale_with_sub_device_10',
        'W1TB_1y_separate_sale_with_sub_device_11',
        'W1TB_1y_separate_sale_with_sub_device_12',
        'W1TB_1y_separate_sale_with_sub_device_13',
        'W1TB_1y_separate_sale_with_sub_device_14',
        'W1TB_1y_separate_sale_with_sub_device_15',
        'W1TB_1y_separate_sale_with_sub_device_16',
        'W1TB_1y_separate_sale_with_sub_device_17',
        'W1TB_1y_separate_sale_with_sub_device_18',
        'W1TB_1y_separate_sale_with_sub_device_19',
        'W1TB_1y_separate_sale_with_sub_device_20',
    ],
};

const multiSessionPresetInSubsExtraPlans: TariffInfo = {
    month: ['W1TB_1m_separate_sale_under_device_5', 'W1TB_1m_separate_sale_under_device_10', 'W1TB_1m_separate_sale_under_device_20'],
    year: ['W1TB_1y_separate_sale_under_device_5', 'W1TB_1y_separate_sale_under_device_10', 'W1TB_1y_separate_sale_under_device_20'],
};

const multiSessionPresetInSubsExtraPlansV2: TariffInfo = {
    month: [
        'W1TB_1m_separate_sale_under_v2_device_5',
        'W1TB_1m_separate_sale_under_v2_device_10',
        'W1TB_1m_separate_sale_under_v2_device_20',
    ],
    year: [
        'W1TB_1y_separate_sale_under_v2_device_5',
        'W1TB_1y_separate_sale_under_v2_device_10',
        'W1TB_1y_separate_sale_under_v2_device_20',
    ],
};

const multiSessionPresetInSubsExtraPlansV3: TariffInfo = {
    month: ['W1TB_1m_separate_sale_under_v3_device_20'],
    year: ['W1TB_1y_separate_sale_under_v3_device_20'],
};

const multiSessionPresetInSubsExtraPlansWithAds: TariffInfo = {
    month: [
        'W1TB_1m_separate_sale_under_with_ads_device_5',
        'W1TB_1m_separate_sale_under_with_ads_device_10',
        'W1TB_1m_separate_sale_under_with_ads_device_20',
    ],
    year: [
        'W1TB_1y_separate_sale_under_with_ads_device_5',
        'W1TB_1y_separate_sale_under_with_ads_device_10',
        'W1TB_1y_separate_sale_under_with_ads_device_20',
    ],
};

const multiSessionFreeChoiceTariffs: TariffInfo = getFeature('multi-session-free-choice-tariffs') || saleDevPlans;

const multiSessionPresetInSubsTariffs: TariffInfo = getFeature('multi-session-preset-in-subs-tariffs') || saleDevWithSubsPlans;

const onlyDeviceProducts = [...multiSessionFreeChoiceTariffs.month, ...multiSessionFreeChoiceTariffs.year];
const deviceWithSubsProducts = [...multiSessionPresetInSubsTariffs.month, ...multiSessionPresetInSubsTariffs.year];
const deviceWithSubsExtraProducts = [
    ...multiSessionPresetInSubsExtraPlans.month,
    ...multiSessionPresetInSubsExtraPlans.year,

    ...multiSessionPresetInSubsExtraPlansV2.month,
    ...multiSessionPresetInSubsExtraPlansV2.year,

    ...multiSessionPresetInSubsExtraPlansV3.month,
    ...multiSessionPresetInSubsExtraPlansV3.year,

    ...multiSessionPresetInSubsExtraPlansWithAds.month,
    ...multiSessionPresetInSubsExtraPlansWithAds.year,
];
const deviceWithSubsExtraProductsWithAds = [
    ...multiSessionPresetInSubsExtraPlansWithAds.month,
    ...multiSessionPresetInSubsExtraPlansWithAds.year,
];

function isFreeChoiceProduct(id: string) {
    return onlyDeviceProducts.includes(id);
}

function isPresetInSubsProduct(id: string) {
    return deviceWithSubsProducts.includes(id) || deviceWithSubsExtraProducts.includes(id);
}

function isPresetInSubsProductWithAds(id: string) {
    return deviceWithSubsExtraProductsWithAds.includes(id);
}

function getDeviceCount(id: string) {
    if (isFreeChoiceProduct(id) || isPresetInSubsProduct(id)) {
        const [_, device] = id.split('_device_');
        return Number(device);
    }
    return 0;
}

type SubsPrices = { month: number; year: number; discount: { month: number; year: number } };
const subsPrices: SubsPrices = getFeature('multi-session-subs-prices') || { month: 599, year: 3980, discount: { month: 499, year: 1990 } };

function getSubPrices(isMonth: boolean, isDiscount: boolean) {
    const regSubPrice = isMonth ? subsPrices.month : subsPrices.year;
    const discountSubPrice = isMonth ? subsPrices.discount.month : subsPrices.discount.year;
    return isDiscount ? discountSubPrice : regSubPrice;
}
/**
 * Вот это вот все (хардкод тарифов, цен, устройств) это временное решение для эксперимента,
 * В последствии избавиться от всего этого и перевести на получение информации из productList/billingData,
 * Как только там эта инфа появится;
 */
export const MultiSessionDeviceSubs = {
    enabled: isFeature('multi-session-subs-enabled'),
    deviceInSubs: getFeature('multi-session-subs-device-count') || 3,
    isFreeChoiceProduct,
    isPresetInSubsProduct,
    isPresetInSubsProductWithAds,
    getDeviceCount,
    getSubPrices,
};
